module.exports = __webpack_public_path__ + "static/media/29BDOS14.d4809e70.jpg";